import { defineMessages } from 'react-intl';

const messages = defineMessages({
  promoBannerHeader: {
    id: 'chatbot.promoBannerHeader',
    defaultMessage: 'SensAI Learner Assistant is here!',
  },
  promoBannerMessage: {
    id: 'chatbot.promoBannerMessage',
    defaultMessage:
      'Our AI powered learner assistant helps you get comprehensive answers, gain deeper knowledge into AWS services, brainstorm effective strategies, and receive tailored training recommendations.',
  },
  promoBannerCTA: {
    id: 'chatbot.promoBannerCTA',
    defaultMessage: 'Explore now',
  },
});

export default messages;
